import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { isDebugSentry, isEnabledSentry } from './consistents';

export function setupSentry() {
  // Sentryのサンプル取得率を制御するための環境変数
  // NOTE サンプル取得率の根拠などの情報は、以下のNotionを参照
  // 参考：https://www.notion.so/1c0a4e41249f8123aaf7e98c9a945dea
  const isValidTracesRate =
    process.env.REACT_APP_SENTRY_ENV === 'prd' ||
    process.env.REACT_APP_SENTRY_ENV === 'stg';
  const isValidReplaysOnErrorRateRate =
    process.env.REACT_APP_SENTRY_ENV === 'prd' ||
    process.env.REACT_APP_SENTRY_ENV === 'stg';

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
        enableInp: true,
      }),
      Sentry.replayIntegration(),
      Sentry.metrics.metricsAggregatorIntegration(),
    ],
    environment: process.env.REACT_APP_SENTRY_ENV,
    enabled: isEnabledSentry,

    // Performance Monitoring
    tracesSampleRate: isValidTracesRate ? 1 : 0,
    // Replay Sessions
    replaysSessionSampleRate: 0,
    // リプレイ上限500件/月のため、1ヶ月間継続的にリプレイを取得できるように調整。
    replaysOnErrorSampleRate: isValidReplaysOnErrorRateRate ? 0.3 : 0,
    allowUrls: [
      ...(isEnabledSentry ? ['localhost'] : []),
      // ClarisLink
      /\.dkclaris\.net/i,
      /\.clarislink\.com/i,
      // Amplify環境は取得していないので、取得したい場合には追加する
    ],

    debug: isDebugSentry,
  });
}
